export default "__VITE_ASSET__Clg10_aQ__"